require('whatwg-fetch')
require('regenerator-runtime/runtime')
